import { render, staticRenderFns } from "./LaboralReferences.vue?vue&type=template&id=4f643a10&"
import script from "./LaboralReferences.vue?vue&type=script&lang=js&"
export * from "./LaboralReferences.vue?vue&type=script&lang=js&"
import style0 from "./LaboralReferences.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports